import reducer from './reducers'

import * as modalFormOperations from './operations'
import * as modalFormTypes from './types'
import * as modalFormHooks from './hooks'

export { modalFormOperations, modalFormTypes, modalFormHooks }

export default reducer
